import {
    ACTION_DECLARATION_OUTLINE_COLOR,
    ALIGNMENT_GUIDE_COLOR,
    ARROW_COLOR,
    BLACK,
    BLOOD_COUNTER_FILL_COLOR,
    BUTTON_BACKGROUND_COLOR,
    BUTTON_BORDER_COLOR,
    CARD_GLOW_COLOR,
    CARD_GLOW_CANDIDATE_COLOR,
    CARD_GLOW_STAGED_COLOR,
    CARD_GROUP_BACKGROUND_COLOR,
    CARD_GROUP_BOUNDING_BOX_COLOR,
    CARD_GROUP_OUTLINE_COLOR,
    CARD_OUTLINE_COLOR_HOVER,
    CARD_OUTLINE_COLOR_INDIRECT_HOVER,
    CARD_OUTLINE_COLOR_SELECTED,
    CARD_PING_COLOR,
    EFFECT_CHIP_FILL_COLOR,
    COUNTER_OUTLINE_COLOR,
    GREEN_COUNTER_FILL_COLOR,
    HIGHLIGHT_YELLOW,
    HOSTAGE_CHIP_FILL_COLOR,
    MARKERS_FILL_COLOR,
    NIGHTMARE_CHIP_FILL_COLOR,
    ORANGE_COUNTER_FILL_COLOR,
    REGION_BACKGROUND_COLOR,
    REGION_STACK_SIZE_BACKGROUND_COLOR,
    SELECTION_AREA_COLOR,
    SEPARATOR_COLOR,
    TORTURE_CHIP_FILL_COLOR,
    WHITE,
    WIELD_BACKGROUND_COLOR,
    WIELD_BORDER_COLOR,
    WIELD_SCROLLBAR_COLOR,
} from '@/shared/const/game.ts'
import Phaser from 'phaser'

const toColor = (value: string) => Phaser.Display.Color.RGBStringToColor(value)

export const Colors = {
    ACTION_DECLARATION_OUTLINE: toColor(ACTION_DECLARATION_OUTLINE_COLOR),
    ALIGNMENT_GUIDE: toColor(ALIGNMENT_GUIDE_COLOR),
    ARROW: toColor(ARROW_COLOR),
    BLACK: toColor(BLACK),
    BLOOD_COUNTER_FILL: toColor(BLOOD_COUNTER_FILL_COLOR),
    BUTTON_BACKGROUND: toColor(BUTTON_BACKGROUND_COLOR),
    BUTTON_BORDER: toColor(BUTTON_BORDER_COLOR),
    CARD_GLOW: toColor(CARD_GLOW_COLOR),
    CARD_GLOW_CANDIDATE: toColor(CARD_GLOW_CANDIDATE_COLOR),
    CARD_GLOW_STAGED: toColor(CARD_GLOW_STAGED_COLOR),
    CARD_GROUP_BACKGROUND: toColor(CARD_GROUP_BACKGROUND_COLOR),
    CARD_GROUP_BOUNDING_BOX: toColor(CARD_GROUP_BOUNDING_BOX_COLOR),
    CARD_GROUP_OUTLINE: toColor(CARD_GROUP_OUTLINE_COLOR),
    CARD_OUTLINE_HOVER: toColor(CARD_OUTLINE_COLOR_HOVER),
    CARD_OUTLINE_INDIRECT_HOVER: toColor(CARD_OUTLINE_COLOR_INDIRECT_HOVER),
    CARD_OUTLINE_SELECTED: toColor(CARD_OUTLINE_COLOR_SELECTED),
    CARD_PING: toColor(CARD_PING_COLOR),
    EFFECT_CHIP_FILL: toColor(EFFECT_CHIP_FILL_COLOR),
    COUNTER_OUTLINE: toColor(COUNTER_OUTLINE_COLOR),
    GREEN_COUNTER_FILL: toColor(GREEN_COUNTER_FILL_COLOR),
    HIGHLIGHT_YELLOW: toColor(HIGHLIGHT_YELLOW),
    HOSTAGE_CHIP_FILL: toColor(HOSTAGE_CHIP_FILL_COLOR),
    MARKERS_FILL: toColor(MARKERS_FILL_COLOR),
    NIGHTMARE_CHIP_FILL: toColor(NIGHTMARE_CHIP_FILL_COLOR),
    ORANGE_COUNTER_FILL: toColor(ORANGE_COUNTER_FILL_COLOR),
    REGION_BACKGROUND: toColor(REGION_BACKGROUND_COLOR),
    REGION_STACK_SIZE_BACKGROUND: toColor(REGION_STACK_SIZE_BACKGROUND_COLOR),
    SELECTION_AREA: toColor(SELECTION_AREA_COLOR),
    SEPARATOR: toColor(SEPARATOR_COLOR),
    TORTURE_CHIP_FILL: toColor(TORTURE_CHIP_FILL_COLOR),
    WHITE: toColor(WHITE),
    WIELD_BACKGROUND: toColor(WIELD_BACKGROUND_COLOR),
    WIELD_BORDER: toColor(WIELD_BORDER_COLOR),
    WIELD_SCROLLBAR: toColor(WIELD_SCROLLBAR_COLOR),
}
